import { Component, HostListener, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DynamicFieldModel } from '@share';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { HttpParams } from '@angular/common/http';
import { LoadingService } from 'src/app/share/services/loading.service';
import { ChangeDetectorRef } from '@angular/core';
import { AppAlertService } from './app-alert.service';
import { CommonModule } from '@angular/common';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-app-alert',
  imports: [DynamicTableComponent,CommonModule],
  providers: [NzModalService],
  templateUrl: './app-alert.component.html',
  styleUrl: './app-alert.component.scss'
})
export class AppAlertComponent implements OnInit {
  constructor(private readonly modalService: NzModalService, private readonly service:AppAlertService,private readonly loadingService: LoadingService, private readonly cdr: ChangeDetectorRef) {

  }
 
  ngOnInit(): void {
    this.calculateWidth();
    
    forkJoin({
      alerts: this.service.getItems()
    })
      .subscribe({
        next: ({ alerts }) => {
          this.schema.columns[1].option = alerts?.data.map((y: any) => ({
            text: y.heading,
            value: y.heading
          })).filter((item: any, index: number, self: any[]) => 
            index === self.findIndex((t: any) => t.text === item.text && t.text)
          );
        },
        error: err => console.error('Error loading options:', err),
        complete: () => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        }
      });
  }
  @HostListener('window:resize')
  calculateWidth() {
    const offsetWidth=300;
    this.width=`${window.innerWidth - offsetWidth}px`;
  }
  width="";
  total: 0;
  schema = {
    name: "Weather Alert List",
    permissionKey: "weatherAlert",
    enableDelete: true,
    enableEdit: true,
    enableAdd: true,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight:false,
        isStickyLeft:true,

      },
      {
        key: "heading",
        title: "Heading",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "200px",
        isStickyRight:false,
        isStickyLeft:false,
      },
      {
        key: "content",
        title: "Content",
        type: "string",
        enableSearch: true,
        searchType: "input",
        width: "200px",
        isStickyRight:false,
        isStickyLeft:false,
      },
      {
        key: "type",
        title: "Alert Type",
        type: "string",
        enableSearch: true,
        searchType: "select",
        isStickyRight:false,
        isStickyLeft:false,
        option: [
          {value:"Weather Alert",text:"Weather Alert"},{value:"Short Alert","text":"Short Alert"}
        ],
        width: "200px"
      },
      {
        key: "published_date",
        title: "Published Date",
        type: "date",
        //enableSearch: true,
        searchType: "date",
        width: "200px",
        isStickyRight:false,
        isStickyLeft:false,
      },
      {
        key: "createdAt",
        title: "Created Date",
        type: "date",
        //enableSearch: true,
        //enableSort: true,
        searchType: "date",
        width: "200px",
        isStickyRight:false,
        isStickyLeft:false,

      },
      {
        key: "updatedAt",
        title: "Updated Date",
        type: "date",
        searchType: "date",
        width: "200px",
        isStickyRight:false,
        isStickyLeft:false,
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight:true,
        isStickyLeft:false,
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }, { name: "delete", type: "danger", isEnable: true }]
      }
    ]
  };
  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Heading',
      name: 'heading',
      type: 'input',
      sortOrder: 1,
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Heading required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
    
    {
      label: 'Content',
      name: 'content',
      type: 'editor',
      placeholder: '',
      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Content required',
        },
      ],
    },
    {
      label: 'Alert Type',
      name: 'type',
      type: 'select',
      required: true,
      placeholder: 'Select Alert Type',
      options: [
        {value:"Weather Alert","text":"Weather Alert"},{value:"Short Alert","text":"Short Alert"}
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Alert Type required',
        },
      ],
    },
  ];

  list: any[] = [];

  change(data: { [key: string]: any }) {
    let params = new HttpParams()
      .set('page', data['pageIndex'].toString())
      .set('pageSize', data['pageSize'].toString())
      .set('filterValue', JSON.stringify(data['filters']))
      .set('sort', JSON.stringify(data['sorts']));
    this.loadData(params);
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading()
    this.service.getItems(param).subscribe({
      next: x => {
      this.list = x.data.filter((item: any) => !item.deleted);
      this.total = x.totalCount;
      },
      error: err => this.loadingService.toggleTableLoading(),
      complete: () => {
        this.loadingService.toggleTableLoading();
        this.cdr.detectChanges();
      }
    });
  }

  formEvent(data: any) {
    if (data.id) {
      this.service.updateItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    else if (data.deleted_id) {
          data.deleted = true;
          this.modalService.confirm({
            nzTitle: 'Are you sure want to delete?',
            nzContent: 'This action cannot be undone.',
            nzOkText: 'Yes',
            nzCancelText: 'No',
            nzOnOk: () => {
              this.service.deleteItem(data).subscribe(x => {
                let params = new HttpParams()
                  .set('page', this.schema.pageIndex.toString())
                  .set('pageSize', this.schema.pageSize.toString());
                this.loadData(params);
              });
            },
            nzOnCancel: () => {
            }
          });
        }
    else {
      this.service.createItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }

  }
}
